"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JKMobile = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var styles = _interopRequireWildcard(require("../../shared_mobile_styles.css"));
var _AddressInput = require("../../../AddressInput");
var _RoomsCountSelector = require("../../../RoomsCountSelector");
var _FilterWithButtonGroup = require("../../../packages/FilterWithButtonGroup");
var _Label = require("../../../Label");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const JKMobile = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(styles['paper'], props.isEmbedded && styles['embedded'])
  }, /*#__PURE__*/React.createElement("form", {
    className: styles['form'],
    onSubmit: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['form-content']
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(styles['form-content-address'], styles['form-content-item'])
  }, /*#__PURE__*/React.createElement(_FilterWithButtonGroup.FilterWithButtonGroup, (0, _extends2.default)({}, props.estimationTargetProps, {
    testId: "estimation_target_control"
  }))), /*#__PURE__*/React.createElement("div", {
    className: (0, _clsx.default)(styles['form-content-address'], styles['form-content-item'])
  }, /*#__PURE__*/React.createElement(_Label.Label, {
    label: "\u0410\u0434\u0440\u0435\u0441 \u0438\u043B\u0438 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0416\u041A"
  }), /*#__PURE__*/React.createElement(_AddressInput.AddressInput, (0, _extends2.default)({
    className: styles['form-content-fixed-height']
  }, props.addressProps))), /*#__PURE__*/React.createElement("div", {
    className: styles['form-content-item']
  }, /*#__PURE__*/React.createElement(_Label.Label, {
    label: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043A\u043E\u043C\u043D\u0430\u0442"
  }), /*#__PURE__*/React.createElement(_RoomsCountSelector.RoomsCountSelector, (0, _extends2.default)({
    className: styles['form-content-fixed-height']
  }, props.jkRoomsCountSelectorProps)))))));
};
exports.JKMobile = JKMobile;
JKMobile.displayName = 'JKMobile';